import { render, staticRenderFns } from "./KvYhteistyo.vue?vue&type=template&id=221b36ac&scoped=true"
import script from "./KvYhteistyo.vue?vue&type=script&lang=js"
export * from "./KvYhteistyo.vue?vue&type=script&lang=js"
import style0 from "./KvYhteistyo.vue?vue&type=style&index=0&id=221b36ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221b36ac",
  null
  
)

export default component.exports